import { render, staticRenderFns } from "./retour.vue?vue&type=template&id=05d04004&scoped=true&"
import script from "./retour.vue?vue&type=script&lang=js&"
export * from "./retour.vue?vue&type=script&lang=js&"
import style0 from "./retour.vue?vue&type=style&index=0&id=05d04004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d04004",
  null
  
)

export default component.exports